import React, { useState } from "react";
import { Content, Footer, Modal, RootLayout } from "./Home.style";
import { Layout, message } from "antd";
import { Breadcrumb, Sidebar, Topbar, SessionExpiredDialog } from "@components";
import { useDispatch } from "react-redux";
import { api, Status } from "@api";
import { localStorage } from "@utils";
import { clearToken } from "@store/auth/authSlice";
import HomeRoutes from "./HomeRoutes";
import { unsubscribeFirebase } from "./firebaseHelper";
import { useTranslation } from "react-i18next";

const Home = () => {
  const dispatch = useDispatch();
  const [logoutStatus, setLogoutStatus] = useState(Status.DEFAULT);
  const [open, setOpen] = useState(false);

  const {t} = useTranslation();
  

 const logout = async () => {
  try {
    // First unsubscribe Firebase
    await unsubscribeFirebase();

    // Now clear session
    resetSessionState();

    message.success(t('logout_successful'));
  } catch (error) {
    console.error("Logout Error:", error);
    message.error("Failed to logout properly.");
  }
};

  const resetSessionState = () => {
    // clear token in redux
    dispatch(clearToken());
    // remove token from localstorage
    localStorage.clearToken();
    // update token in request obj
    api.setSessionToken("");

    // remove admin from localstorage
    localStorage.clearAdmin();
  };

  const renderHeader = () => {
    return (
      <>
        <Topbar openModal={() => setOpen(true)} />
        <Modal
          centered
          closable={false}
          open={open}
          confirmLoading={logoutStatus === Status.LOADING}
          onCancel={() => logoutStatus !== Status.LOADING && setOpen(false)}
          onOk={logout}
           cancelText={t('cancel')}
          okText={t('ok')}
          okButtonProps={{
          style: {
            width:"100px",
            color: "#fff",
            height: "40px",
            borderRadius: "12px",
            paddingInline: "24px",
          },
        }}
        cancelButtonProps={{
          style: {
            height: "40px",
            width:"100px",
            borderRadius: "12px",
            paddingInline: "24px",
          },
        }}
        >
          {t('are_you_logout')}
        </Modal>
      </>
    );
  };

  const renderFooter = () => {
    return <Footer>© 2023 Business Admin. All Rights Reserved.</Footer>;
  };

  return (
    <>
      <RootLayout>
        {renderHeader()}
        <Layout>
          <Sidebar />
          <Layout>
            <Content>
              <HomeRoutes />
            </Content>
          </Layout>
        </Layout>
      </RootLayout>

      <SessionExpiredDialog handleClick={resetSessionState} />
    </>
  );
};

export default Home;
